import { render, staticRenderFns } from "./ModalFormAgregarCEUB.vue?vue&type=template&id=1f22d52a&scoped=true"
import script from "./ModalFormAgregarCEUB.vue?vue&type=script&lang=js"
export * from "./ModalFormAgregarCEUB.vue?vue&type=script&lang=js"
import style0 from "./ModalFormAgregarCEUB.vue?vue&type=style&index=0&id=1f22d52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22d52a",
  null
  
)

export default component.exports